import { c as _c } from "react/compiler-runtime";
import useUser from 'shared/hooks/use-user';
import { useFirstAvailableRoute } from 'shared/hooks/use-first-available-route';
import { HeaderLogo } from './header-logo';
const SioButton = () => {
  const $ = _c(2);
  const {
    user,
    isDisabled
  } = useUser();
  const {
    firstAvailableRoute
  } = useFirstAvailableRoute();
  const t0 = user && !isDisabled ? firstAvailableRoute : undefined;
  let t1;
  if ($[0] !== t0) {
    t1 = <HeaderLogo href={t0} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default SioButton;